import React from 'react';
import { theme as theme_1 } from '../../../../design-tokens/build/index.js';
import BoxArrow from '../BoxArrow/BoxArrow.js';
import { AlertBox as AlertBox$1, IconContainer } from './AlertBox.styles.js';

function AlertBox(_a) {
  var _b, _c;

  var _d = _a.background,
      background = _d === void 0 ? (_b = theme_1.palette) === null || _b === void 0 ? void 0 : _b.blueLight : _d,
      _e = _a.borderColor,
      borderColor = _e === void 0 ? (_c = theme_1.palette) === null || _c === void 0 ? void 0 : _c.alertBlue : _e,
      icon = _a.icon,
      _f = _a.iconMinWidth,
      iconMinWidth = _f === void 0 ? 24 : _f,
      withArrow = _a.withArrow,
      arrowSpacing = _a.arrowSpacing,
      arrowPlacement = _a.arrowPlacement,
      _g = _a.padding,
      padding = _g === void 0 ? 16 : _g,
      children = _a.children;
  return React.createElement("div", null, withArrow && React.createElement(BoxArrow, {
    arrowPlacement: arrowPlacement,
    arrowSpacing: arrowSpacing,
    background: background
  }), React.createElement(AlertBox$1, {
    background: background,
    borderColor: borderColor,
    padding: padding
  }, icon && React.createElement(IconContainer, {
    minWidth: iconMinWidth
  }, icon), children));
}

export { AlertBox };